// Import directly from the core implementation to avoid circular deps
import Vue from 'vue'
import { defineStore } from '~/plugins/pinia-core'
import { defaultParams } from '@/utils/constants'

// We'll need this to access Nuxt's $axios
let $axios = null

export const useStoreLocatorStore = defineStore('storeLocator', {
  state: () => ({
    selectedStore: {},
    storeLocatorConfig: {},
    coordinates: {
      lat: undefined,
      lng: undefined,
    },
    defaultCoordinates: {
      lat: undefined,
      lng: undefined,
    },
    bounds: {
      Ha: undefined,
      Ua: undefined,
    },
    allStores: [],
    nearestStores: [],
    coreLibrary: null,
    mapsLibrary: null,
    geocodingLibrary: null,
    geometryLibrary: null,
    markerLibrary: null,
    error: {},
    resultsOffsetTop: null,
  }),

  actions: {
    // In Pinia, mutations are replaced with actions that directly modify state
    ADD_ERROR(error) {
      Vue.set(this, 'error', error)
    },

    CLEAR_ERROR() {
      Vue.set(this, 'error', {})
    },

    SET_STORE_LOCATOR_CONFIG(config) {
      Vue.set(this, 'storeLocatorConfig', config)
    },

    SET_COORDINATES(coordinates) {
      Vue.set(this, 'coordinates', coordinates)
    },

    SET_DEFAULT_COORDINATES(defaultCoordinates) {
      Vue.set(this, 'defaultCoordinates', defaultCoordinates)
    },

    SET_BOUNDS(bounds) {
      Vue.set(this, 'bounds', bounds)
    },

    SET_CORE_LIBRARY(coreLibrary) {
      Vue.set(this, 'coreLibrary', coreLibrary)
    },

    SET_MAPS_LIBRARY(mapsLibrary) {
      Vue.set(this, 'mapsLibrary', mapsLibrary)
    },

    SET_GEOCODING_LIBRARY(geocodingLibrary) {
      Vue.set(this, 'geocodingLibrary', geocodingLibrary)
    },

    SET_GEOMETRY_LIBRARY(geometryLibrary) {
      Vue.set(this, 'geometryLibrary', geometryLibrary)
    },

    SET_MARKER_LIBRARY(markerLibrary) {
      Vue.set(this, 'markerLibrary', markerLibrary)
    },

    SET_ALL_STORES(allStores) {
      Vue.set(this, 'allStores', allStores)
    },

    SET_NEAREST_STORES(nearestStores) {
      Vue.set(this, 'nearestStores', nearestStores)
    },

    SET_SELECTED_STORE(selectedStore) {
      Vue.set(this, 'selectedStore', selectedStore)
    },

    SET_RESULTS_OFFSET_TOP(resultsOffsetTop) {
      Vue.set(this, 'resultsOffsetTop', resultsOffsetTop)
    },

    // Main action to get store locator configuration
    async getStoreLocatorConfig() {
      try {
        const response = await $axios.get('/configuration/store-locator', { params: defaultParams, useCache: true })
        const { data } = response.data
        this.SET_STORE_LOCATOR_CONFIG(data)
      } catch (error) {
        this.ADD_ERROR({ type: 'config', error })
      }
    },
  },
})

// Initialization function to provide Nuxt resources to the store
export function initializeStoreLocatorStore(nuxtAxios) {
  $axios = nuxtAxios
}
